import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FanIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FanIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.8095 2.11572C7.35945 2.11572 2.92529 6.54988 2.92529 12C2.92529 17.4501 7.35945 21.8842 12.8095 21.8842C18.2596 21.8842 22.6938 17.4501 22.6938 12C22.6938 6.54988 18.2596 2.11572 12.8095 2.11572ZM12.8095 20.6487C8.04056 20.6487 4.16082 16.769 4.16082 12C4.16082 7.23099 8.04056 3.35125 12.8095 3.35125C17.5785 3.35125 21.4583 7.23099 21.4583 12C21.4583 16.769 17.5785 20.6487 12.8095 20.6487Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.5163 8.29303C15.2268 8.29303 14.0917 8.95642 13.4274 9.95818V5.2042C13.4274 4.86274 13.1511 4.58643 12.8097 4.58643C10.7657 4.58643 9.10308 6.24908 9.10308 8.29302C9.10308 9.58247 9.76647 10.7176 10.7682 11.3818H6.01425C5.67279 11.3818 5.39648 11.6582 5.39648 11.9996C5.39648 14.0436 7.05913 15.7062 9.10307 15.7062C10.3925 15.7062 11.5277 15.0428 12.1919 14.0411V18.795C12.1919 19.1365 12.4682 19.4128 12.8097 19.4128C14.8536 19.4128 16.5163 17.7502 16.5163 15.7062C16.5163 14.4168 15.8529 13.2816 14.8511 12.6174H19.6051C19.9466 12.6174 20.2229 12.3411 20.2229 11.9996C20.2229 9.95568 18.5602 8.29303 16.5163 8.29303ZM9.10308 14.4707C7.95382 14.4707 6.98493 13.6822 6.71045 12.6174H11.4957C11.2212 13.6822 10.2523 14.4707 9.10308 14.4707ZM10.3386 8.29303C10.3386 7.14377 11.1271 6.17488 12.1919 5.9004V10.6857C11.1271 10.4112 10.3386 9.44228 10.3386 8.29303ZM12.8097 12.6174C12.4685 12.6174 12.1919 12.3408 12.1919 11.9996C12.1919 11.6584 12.4685 11.3818 12.8097 11.3818C13.1508 11.3818 13.4274 11.6584 13.4274 11.9996C13.4274 12.3408 13.1508 12.6174 12.8097 12.6174ZM15.2807 15.7062C15.2807 16.8555 14.4922 17.8244 13.4274 18.0988V13.3136C14.4922 13.5881 15.2807 14.557 15.2807 15.7062ZM14.1236 11.3819C14.3981 10.3171 15.367 9.52856 16.5163 9.52856C17.6655 9.52856 18.6344 10.3171 18.9089 11.3819H14.1236Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FanIcon;
